module.exports = __webpack_public_path__ + "static/media/choose-type-modal2.c8ce56e7.svg";